import React from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { colors } from '../../../../../../constants/colors';
import { safeGet } from '../../../../../../core/util/object';

const Root = styled.a.withConfig({ componentId: 'sc-vy2mug-0' })`
  color: ${colors.blueJayWay};
  font-size: ${fontSize.default};
  font-family: ${fontFamily.bold};
  width: 240px;
  height: 50px;
  border: 2px solid ${colors.blueJayWay};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  location: any;
};

const CallClinicButton = ({ location }: Props) => {
  if (!safeGet(location)('phone')) return null;

  return <Root href={`tel:${location.phone}`}>Call Clinic</Root>;
};

export default CallClinicButton;
